import {
  ICheckoutNotification,
  IProduct,
  NotificationEnum,
} from '@monofront/types';
import { useEffect } from 'react';
import { Channel } from '../constants';
import { ProductService } from '../services';

export interface INotificationHandlerProps {
  type: NotificationEnum;
  message: string;
  product?: IProduct;
}

/**
 *
 * @param notificationHandler a method that will handle the display of the notification
 * @param ProductService the service that gets the products informations
 * @param channel to target correct product service
 * @returns  a hook that is used in the checkout to display notifications returned by the sync and refresh apis
 */
export const createUseHandleNotifications =
  (
    notificationHandler: (options: INotificationHandlerProps) => any,
    ProductService: ProductService,
    channel: Channel = Channel.FR,
  ) =>
  (notifications?: [ICheckoutNotification]) => {
    useEffect(() => {
      const handleNotifications = async () => {
        const products = await ProductService.getProductsBySku(
          notifications!.reduce((acc: string[], { details }) => {
            if (!details?.sku) {
              return acc;
            }

            acc.push(details.sku);

            return acc;
          }, []),
          channel as Channel,
        );

        notifications!.forEach(({ type, details, translatedMessage }) =>
          notificationHandler({
            type: type,
            message: translatedMessage,
            product: details.sku
              ? products?.find(({ sku }) => sku === details.sku)
              : undefined,
          }),
        );
      };

      if (notifications) {
        handleNotifications();
      }
    }, [notifications]);
  };
